<template>
  <div class="conten">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="secah.phone" placeholder="请输入运营中心手机号"></el-input>
        </el-form-item>
        <el-form-item label="运营商级别" label-width='100px'>
          <el-select clearable v-model="secah.operationLevel" placeholder="请选择运营商级别">
            <el-option label="全部" value=""></el-option>
            <el-option label="省级运营商" :value="1"></el-option>
            <el-option label="市级运营商" :value="2"></el-option>
            <el-option label="区级运营商" :value="3"></el-option>
            <el-option label="技术运营商" :value="4"></el-option>
            <el-option label="核心运营商" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click='secahClick'>搜索</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="operationLevel" label="级别" align="center">
          <template slot-scope="scope">
            {{getLevel(scope.row.operationLevel)}}
          </template>
        </el-table-column>
        <el-table-column prop="appUserId" label="用户id" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="benefitScore" label="效益分" align="center"></el-table-column>
        <el-table-column prop="earnings" label="收益" align="center"></el-table-column>
        <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      secah: {
        pageSize: 10,
        pageNum: 1,
        phone: '',
        operationLevel: '',
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    //搜索
    secahClick() {
      this.secah.pageNum = 1
      this.getList()
    },
    getLevel(level) {
      if (level == 1) {
        return '省级运营商'
      } else if (level == 2) {
        return '市级运营商'
      } else if (level == 3) {
        return '区级运营商'
      } else if (level == 4) {
        return '技术运营商'
      } else if (level == 5) {
        return '核心运营商'
      }
    },
    getState(state) {
      if (state == 0) {
        return '待审核'
      } else if (state == 1) {
        return '审核通过'
      } else if (state == 2) {
        return '审核不通过'
      }
    },
    //选择分页条数
    handleSizeChange(e) {
      this.secah.pageNum = 1
      this.secah.pageSize = e
      this.getList()
    },
    //页码
    handleCurrentChange(e) {
      this.secah.pageNum = e
      this.getList()
    },
    //获取数据
    getList() {
      var secah = this.secah
      this.httpGet('/admin/operation/partner/earningsRecords', secah, true).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.list
          this.total = res.data.total
        }
      })
    },
  },
}
</script>

<style scoped lang='scss'>
.page {
  padding: 20px 0;
}
</style>
